var Models = require('models/base/model');

module.exports = Models.extend({
  defaults: {
    _PASS: 39228,
    _YEAR: 2013
  }
});